import { render, staticRenderFns } from "./UsernamePasswordChangeModal.vue?vue&type=template&id=35b7c754"
import script from "./UsernamePasswordChangeModal.vue?vue&type=script&lang=js"
export * from "./UsernamePasswordChangeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports